// extracted by mini-css-extract-plugin
module.exports = {"page":"PayContent_page__2MKeF"};